<template>
  <div id="app">
    <router-view
      name="header"
      @update-header-height="updateHeaderHeight"
    ></router-view>
    <main :style="{ paddingTop: headerHeight + 'px' }">
      <transition :name="$route.meta.transition || 'fade'">
        <router-view></router-view>
      </transition>
    </main>
    <router-view name="footer"></router-view>

    <loading :is-loading="isLoading" />
  </div>
</template>

<script>
import Loading from "./components/Loading.vue";

export default {
  name: "App",
  components: {
    Loading,
  },
  data() {
    return {
      isLoading: false,
      headerHeight: 70,
    };
  },
  methods: {
    updateHeaderHeight(height) {
      this.headerHeight = height;
    },
  },
  created() {
    this.$router.beforeEach((to, from, next) => {
      this.isLoading = true;
      next();
    });

    this.$router.afterEach(() => {
      // Using a timeout to avoid flickering on fast route changes
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    });
  },
};
</script>

<style>
#app {
  --bjp-petrol-950: #062f36;
  --bjp-petrol-900: #0a3f49;
  --bjp-petrol-800: #11515d;
  --bjp-petrol-700: #1b6470;
  --bjp-secondary: #11515d;
  --bjp-gold-700: #a98225;
  --bjp-gold-600: #c5a746;
  --bjp-gold-400: #e6cb72;
  --bjp-gold-200: #ead590;
  --bjp-ivory: #ead590;
  --bjp-cream: #d8bd68;
  --bjp-ink: #14343a;
  --bjp-surface: rgba(6, 47, 54, 0.82);
  --bjp-surface-solid: #0a3f49;
  --bjp-border: rgba(230, 203, 114, 0.28);
  min-height: 100vh;
  overflow-x: hidden;
  color: var(--bjp-ink);
  background-color: var(--bjp-gold-600);
  background-image: url("./assets/bjp/Fondo Juancito portal.jpeg");
  background-position: center;
  background-size: cover;
  background-attachment: fixed;
}

main {
  min-height: calc(100vh - 80px);
  background-color: transparent;
}

/* route transition base styles */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease;
}
.fade-enter,
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.slide-left-enter-active,
.slide-left-leave-active {
  transition: transform 0.25s ease, opacity 0.25s ease;
}
.slide-left-enter,
.slide-left-enter-from,
.slide-left-leave-to {
  transform: translateX(16px);
  opacity: 0;
}
@media (max-width: 767px) {
  #app {
    background-attachment: scroll;
  }
}
</style>
